import { createRoute } from '@tanstack/react-router'
import { AddUserPage } from '@/features/users/pages/AddUserPage'
import { Route as usersRoute } from './route'

export const Route = createRoute({
  getParentRoute: () => usersRoute,
  path: '/add',
  component: AddUserPage,
})
